import React from "react";
import { Flex, Text } from "@kui/foundations-react";
import "./styles.css";

const LINKS = [
  ["Privacy Policy", "https://www.nvidia.com/en-us/about-nvidia/privacy-policy/"],
  ["Your Privacy Choices", "https://www.nvidia.com/en-us/privacy-center/"],
  ["Terms of Service", "https://www.nvidia.com/en-us/about-nvidia/terms-of-service/"],
  ["Accessibility", "https://www.nvidia.com/en-us/about-nvidia/accessibility/"],
  ["Corporate Policies", "https://www.nvidia.com/en-us/about-nvidia/company-policies/"],
  ["Product Security", "https://www.nvidia.com/en-us/product-security/"],
  ["Contact", "https://www.nvidia.com/en-us/contact/"],
];

export const SimpleFooter = () => (
  <Flex asChild direction="col" gap="4" className="simple-footer">
    <footer>
      <Flex asChild align="center" wrap="wrap" gap="2">
        <nav aria-label="Footer">
          {LINKS.map(([label, href], i) => (
            <React.Fragment key={label}>
              {i > 0 && (
                <Text kind="body/regular/md" aria-hidden="true">
                  |
                </Text>
              )}
              <Text asChild kind="body/regular/md">
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {label}
                </a>
              </Text>
            </React.Fragment>
          ))}
        </nav>
      </Flex>
      <Text kind="label/regular/sm">
        Copyright © {new Date().getFullYear()} NVIDIA Corporation
      </Text>
    </footer>
  </Flex>
);

export default SimpleFooter;
